import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/** Starts the team's catalog classification sweep, or joins the one running. */
export const startHsaClassificationSweep = {
  name: "startHsaClassificationSweep" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({ workflowId: z.string() }),
};
